import React from "react";

const SITE = "Affiliated Connections";
const DEFAULT_IMG = "https://images.unsplash.com/photo-1672872476232-da16b45c9001?fm=jpg&q=80&w=1200";
const DEFAULT_DESC =
  "Affiliated Connections is the neon bazaar of the best affiliate deals online — a one-stop affiliate marketing deals store. Browse tech, home, fashion, outdoor and more, with real reviews and real prices.";
const DEFAULT_KEYWORDS =
  "affiliate deals, affiliate marketing, affiliate links, online deals, deals store, discount deals, best offers, sponsored links, shopping deals";

// React 19 natively hoists <title>, <meta> and <link> to <head>, so we render
// them directly (no react-helmet needed). Only ONE <Seo> should render per route.
export default function Seo({ title, description, image, path = "", jsonLd, keywords, type = "website" }) {
  const fullTitle = title ? `${title} | ${SITE}` : `${SITE} — Fantastic Affiliate Deals`;
  const url = typeof window !== "undefined" ? `${window.location.origin}${path}` : path;
  const img = image || DEFAULT_IMG;
  const desc = description || DEFAULT_DESC;
  const kw = keywords || DEFAULT_KEYWORDS;
  const blocks = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];
  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta name="keywords" content={kw} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={img} />
      <meta property="og:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
      {blocks.map((b, i) => (
        <script key={i} type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(b) }} />
      ))}
    </>
  );
}
